<ng-template #resourceCard let-titleKey="titleKey" let-contentKey="contentKey">
  <article class="need-help-card">
    <div class="need-help-card__row">
      <div class="need-help-card__content">
        <h4 class="need-help-card__title">{{ titleKey | translate: translations }}</h4>
        <p class="need-help-card__body">{{ contentKey | translate: translations }}</p>
      </div>
      @if (getTelLink(contentKey); as tel) {
        <a
          [href]="tel"
          class="need-help-card__call-btn">
          {{ 'callButtonText' | translate: translations }}
        </a>
      }
    </div>
  </article>
</ng-template>

<div class="need-help-dialog">
  <div class="need-help-scroll">
    <div [hidden]="!isUserCoached">
      <div [hidden]="!isUserInBC">
        <div class="need-help-lead">
          <h4 class="need-help-lead__title">{{'needHelp1stLineBCCoached'|translate:translations}}</h4>
          <p class="need-help-lead__text">{{'needHelp1stLineBCContentCoached'|translate:translations}}</p>
        </div>
        <div class="need-help-grid">
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp2ndLineBCCoached', contentKey: 'needHelp2ndLineBCContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp3rdLineBCCoached', contentKey: 'needHelp3rdLineBCContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp4thLineBCCoached', contentKey: 'needHelp4thLineBCContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp5thLineBCCoached', contentKey: 'needHelp5thLineBCContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp6thLineBCCoached', contentKey: 'needHelp6thLineBCContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp7thLineBCCoached', contentKey: 'needHelp7thLineBCContentCoached' }"></ng-container>
        </div>
        <p class="need-help-footnote">{{'needHelp8thLineBCContentCoached'|translate:translations}}</p>
      </div>

      <div [hidden]="!isUserInOntario">
        <div class="need-help-lead">
          <h4 class="need-help-lead__title">{{'needHelp1stLineONTCoached'|translate:translations}}</h4>
          <p class="need-help-lead__text">{{'needHelp1stLineONTContentCoached'|translate:translations}}</p>
        </div>
        <div class="need-help-grid">
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp2ndLineONTCoached', contentKey: 'needHelp2ndLineONTContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp3rdLineONTCoached', contentKey: 'needHelp3rdLineONTContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp4thLineONTCoached', contentKey: 'needHelp4thLineONTContentCoached' }"></ng-container>
        </div>
      </div>

      <div [hidden]="!isUserInQuebec">
        <div class="need-help-single-row">
          <p class="need-help-single">{{'needHelp1stLineQCContentCoached'|translate:translations}}</p>
          @if (getTelLink('needHelp1stLineQCContentCoached'); as tel) {
            <a
              [href]="tel"
              class="need-help-card__call-btn">
              {{ 'callButtonText' | translate: translations }}
            </a>
          }
        </div>
      </div>

      <div [hidden]="!isUserInNewBrunswick">
        <div class="need-help-lead">
          <h4 class="need-help-lead__title">{{'needHelp1stLineNBCoached'|translate:translations}}</h4>
          <p class="need-help-lead__text">{{'needHelp1stLineNBContentCoached'|translate:translations}}</p>
        </div>
        <div class="need-help-grid">
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp2ndLineNBCoached', contentKey: 'needHelp2ndLineNBContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp3rdLineNBCoached', contentKey: 'needHelp3rdLineNBContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp4thLineNBCoached', contentKey: 'needHelp4thLineNBContentCoached' }"></ng-container>
        </div>
        <p class="need-help-footnote">{{'needHelp5thLineNBContentCoached'|translate:translations}}</p>
      </div>

      <div [hidden]="!isUserInManitoba">
        <div class="need-help-lead">
          <h4 class="need-help-lead__title">{{'needHelp1stLineMBCoached'|translate:translations}}</h4>
          <p class="need-help-lead__text">{{'needHelp1stLineMBContentCoached'|translate:translations}}</p>
        </div>
        <div class="need-help-grid">
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp2ndLineMBCoached', contentKey: 'needHelp2ndLineMBContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp3rdLineMBCoached', contentKey: 'needHelp3rdLineMBContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp4thLineMBCoached', contentKey: 'needHelp4thLineMBContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp5thLineMBCoached', contentKey: 'needHelp5thLineMBContentCoached' }"></ng-container>
        </div>
      </div>

      <div [hidden]="!isUserInOther">
        <div class="need-help-lead">
          <h4 class="need-help-lead__title">{{'needHelp1stLineOtherCoached'|translate:translations}}</h4>
          <p class="need-help-lead__text">{{'needHelp1stLineOtherContentCoached'|translate:translations}}</p>
        </div>
        <div class="need-help-grid">
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp2ndLineOtherCoached', contentKey: 'needHelp2ndLineOtherContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp3rdLineOtherCoached', contentKey: 'needHelp3rdLineOtherContentCoached' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp4thLineOtherCoached', contentKey: 'needHelp4thLineOtherContentCoached' }"></ng-container>
        </div>
        <p class="need-help-footnote">{{'needHelp5thLineOtherContentCoached'|translate:translations}}</p>
      </div>
    </div>

    <div [hidden]="!isUserSelfGuided">
      <div [hidden]="!isUserInBC">
        <div class="need-help-lead">
          <h4 class="need-help-lead__title">{{'needHelp1stLineBCSelfGuided'|translate:translations}}</h4>
          <p class="need-help-lead__text">{{'needHelp1stLineBCContentSelfGuided'|translate:translations}}</p>
        </div>
        <div class="need-help-grid">
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp2ndLineBCSelfGuided', contentKey: 'needHelp2ndLineBCContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp3rdLineBCSelfGuided', contentKey: 'needHelp3rdLineBCContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp4thLineBCSelfGuided', contentKey: 'needHelp4thLineBCContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp5thLineBCSelfGuided', contentKey: 'needHelp5thLineBCContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp6thLineBCSelfGuided', contentKey: 'needHelp6thLineBCContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp7thLineBCSelfGuided', contentKey: 'needHelp7thLineBCContentSelfGuided' }"></ng-container>
        </div>
        <p class="need-help-footnote">{{'needHelp8thLineBCContentSelfGuided'|translate:translations}}</p>
      </div>

      <div [hidden]="!isUserInOntario">
        <div class="need-help-lead">
          <h4 class="need-help-lead__title">{{'needHelp1stLineONTSelfGuided'|translate:translations}}</h4>
          <p class="need-help-lead__text">{{'needHelp1stLineONTContentSelfGuided'|translate:translations}}</p>
        </div>
        <div class="need-help-grid">
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp2ndLineONTSelfGuided', contentKey: 'needHelp2ndLineONTContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp3rdLineONTSelfGuided', contentKey: 'needHelp3rdLineONTContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp4thLineONTSelfGuided', contentKey: 'needHelp4thLineONTContentSelfGuided' }"></ng-container>
        </div>
      </div>

      <div [hidden]="!isUserInQuebec">
        <div class="need-help-single-row">
          <p class="need-help-single">{{'needHelp1stLineQCContentSelfGuided'|translate:translations}}</p>
          @if (getTelLink('needHelp1stLineQCContentSelfGuided'); as tel) {
            <a
              [href]="tel"
              class="need-help-card__call-btn">
              {{ 'callButtonText' | translate: translations }}
            </a>
          }
        </div>
      </div>

      <div [hidden]="!isUserInNewBrunswick">
        <div class="need-help-lead">
          <h4 class="need-help-lead__title">{{'needHelp1stLineNBSelfGuided'|translate:translations}}</h4>
          <p class="need-help-lead__text">{{'needHelp1stLineNBContentSelfGuided'|translate:translations}}</p>
        </div>
        <div class="need-help-grid">
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp2ndLineNBSelfGuided', contentKey: 'needHelp2ndLineNBContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp3rdLineNBSelfGuided', contentKey: 'needHelp3rdLineNBContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp4thLineNBSelfGuided', contentKey: 'needHelp4thLineNBContentSelfGuided' }"></ng-container>
        </div>
        <p class="need-help-footnote">{{'needHelp5thLineNBContentSelfGuided'|translate:translations}}</p>
      </div>

      <div [hidden]="!isUserInManitoba">
        <div class="need-help-lead">
          <h4 class="need-help-lead__title">{{'needHelp1stLineMBSelfGuided'|translate:translations}}</h4>
          <p class="need-help-lead__text">{{'needHelp1stLineMBContentSelfGuided'|translate:translations}}</p>
        </div>
        <div class="need-help-grid">
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp2ndLineMBSelfGuided', contentKey: 'needHelp2ndLineMBContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp3rdLineMBSelfGuided', contentKey: 'needHelp3rdLineMBContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp4thLineMBSelfGuided', contentKey: 'needHelp4thLineMBContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp5thLineMBSelfGuided', contentKey: 'needHelp5thLineMBContentSelfGuided' }"></ng-container>
        </div>
      </div>

      <div [hidden]="!isUserInOther">
        <div class="need-help-lead">
          <h4 class="need-help-lead__title">{{'needHelp1stLineOtherSelfGuided'|translate:translations}}</h4>
          <p class="need-help-lead__text">{{'needHelp1stLineOtherContentSelfGuided'|translate:translations}}</p>
        </div>
        <div class="need-help-grid">
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp2ndLineOtherSelfGuided', contentKey: 'needHelp2ndLineOtherContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp3rdLineOtherSelfGuided', contentKey: 'needHelp3rdLineOtherContentSelfGuided' }"></ng-container>
          <ng-container *ngTemplateOutlet="resourceCard; context: { titleKey: 'needHelp4thLineOtherSelfGuided', contentKey: 'needHelp4thLineOtherContentSelfGuided' }"></ng-container>
        </div>
        <p class="need-help-footnote">{{'needHelp5thLineOtherContentSelfGuided'|translate:translations}}</p>
      </div>
    </div>
  </div>

  <div class="need-help-dialog__actions">
    <button type="button" class="need-help-dialog__btn submit-form-button" [ngClass]="participantClassByRole" (click)="onCloseClick()">{{'closeButtonText'|translate:translations}}</button>
  </div>
</div>
